import React, {createContext, useEffect, useMemo, useState} from 'react';
import {useHistory} from '../useHistory';
import {useCanGoBack_PRIVATE} from './useCanGoBack';

const CanGoBackContext = createContext<{
  canGoBack: boolean;
  isLastNavigationHistoryBack: boolean;
}>({
  canGoBack: false,
  isLastNavigationHistoryBack: false,
});

export const CanGoBackProvider = ({children}: {children: React.ReactNode}) => {
  // eslint-disable-next-line no-restricted-syntax
  const historyBackPossible = useCanGoBack_PRIVATE();
  const history = useHistory();

  const [isLastNavigationHistoryBack, setIsLastNavigationHistoryBack] =
    useState(false);

  useEffect(() => {
    return history.listen(
      (_, action) => {
        // eslint-disable-next-line local-rules/set-state-in-use-effect
        setIsLastNavigationHistoryBack(action === 'POP');
      },
      {disableUiUpdates: true},
    );
  }, [history]);

  const value = useMemo(
    () => ({
      canGoBack: historyBackPossible,
      isLastNavigationHistoryBack,
    }),
    [historyBackPossible, isLastNavigationHistoryBack],
  );

  return (
    <CanGoBackContext.Provider value={value}>
      {children}
    </CanGoBackContext.Provider>
  );
};

export const useCanGoBack = () => React.useContext(CanGoBackContext).canGoBack;
export const useIsLastNavigationHistoryBack = () =>
  React.useContext(CanGoBackContext).isLastNavigationHistoryBack;
